/* Spanish catalog mirroring locale-journal-recovery-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'journalRecovery.title': 'La contabilidad no está disponible temporalmente',
  'journalRecovery.description': 'No se pudo verificar el libro diario. Las páginas contables y las modificaciones permanecen bloqueadas hasta que la comprobación se complete. Puedes contactar con soporte o cambiar de empresa desde el menú.',
  'journalRecovery.reference': 'Empresa: {businessId} · Ejercicio: {year}',
  'journalRecovery.retry': 'Reintentar',
  'journalRecovery.retrying': 'Verificando …',
  'journalRecovery.support': 'Contactar con soporte',
  'journalRecovery.signOut': 'Cerrar sesión',
  'journalRecovery.writeBlocked': 'El libro diario no está disponible. Inténtalo de nuevo antes de modificar la contabilidad.'
});
